const t = "{{currentTime}} af {{duration}}", n = "Leitarniðurstaða {{current}} af {{total}}", s = "Engar niðurstöður fundust", r = "{{count}} niðurstaða fannst", a = "{{count}} niðurstöður fundust", o = 'Spilar frá $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) og $t(SECONDS, { "count": {{seconds}} }).', A = 'Spilar frá $t(MINUTES, { "count": {{minutes}} }) og $t(SECONDS, { "count": {{seconds}} }).', E = 'Spilar frá $t(SECONDS, { "count": {{seconds}} }).', i = "Villa við að vista breytingar á eftirritun.", c = "Lína eftirritunar kl. {{time}}. Efni er: {{text}}.", T = 'Ílát lína eftirritunar. Það er $t(TRANSCRIPT_LINES, { "count": {{count}} }) inni í þessu íláti. Notaðu upp og niður örvar til að fara um inni í þessu íláti.', S = "Vistar breytingar...", _ = "Breytingar vistaðar í eftirritun.", u = "Hnappurinn til að uppfæra skjátexta er núna tiltækur.", N = "Aðgerð", e = "Bæta við athugasemd á {{time}}", R = "Bæta við spurningu á {{time}}", l = "Athugasemdir", O = "Sjálfvirkt", I = "Sjálfvirkt ({{quality}})", C = "Til baka", U = "Skjátextar", P = "Tungumál skjátexta", L = "Stjórna skjátextum", k = "Eyða {{language}}", D = "Leturstærð", f = "Tungumál skjátexta: {{language}}", M = "{{language}} (sjálfvirkt)", p = "Hreinsa leit", m = "Loka", g = "Athugasemdir", G = "Halda áfram", d = "Minnka hraða spilunar", Y = "Minnka hljóðstyrk um {{percent}}%", H = "Niður ör", V = "Loka ritli eftirritunar", y = "Uppfæra skjátexta", B = "Villa!", h = "Vista...", j = "Vistað!", v = "Breyta eftirritun", F = "Texti má ekki vera tómur!", x = "Allur skjárinn", K = "{{count}} klukkustund", W = "{{count}} klukkustundir", $ = "Auka hraða spilunar", Q = "Auka hljóðstyrk um {{percent}}%", b = "Víxla litum", J = "Fara í ákveðið prósentuhlutfall (1-10%, 2-20%, o.s.frv.)", Z = "Fara í Byrja", X = "Aðgerðir fyrir {{title}}", q = "Flýtilyklar", w = "Tungumál", z = "Vinstri ör", tt = "Aðalvalmynd", nt = "{{count}} mínúta", st = "{{count}} mínútur", rt = "Hljóðlaust", at = "Óvirkt", ot = "Næsta tungumál skjátexta", At = "Næsta leitarniðurstaða", Et = "Slökkt", it = "Efst", ct = "Opna athugasemd á {{time}}", Tt = "Opna lokið próf á {{time}}", St = "Opna próf á {{time}}", _t = "Gera hlé", ut = "Spila", Nt = "Hraði spilunar", et = "Hraði spilunar: {{speed}}x", Rt = "Fyrra tungumál skjátexta", lt = "Fyrri leitarniðurstaða", Ot = "Gæði", It = "Gæðavalmynd", Ct = "Spila aftur", Ut = "Endurstilla hraða spilunar", Pt = "Hægri ör", Lt = "Leita í eftirritun", kt = "{{count}} sekúnda", Dt = "{{count}} sekúndur", ft = "Fara til baka: {{seconds}} sekúndur", Mt = "Fara áfram: {{seconds}} sekúndur", pt = "Stillingar", mt = "Flýtileið", gt = "Upplýsingar margmiðlunarefnis og verkfæri", Gt = "Bil", dt = "Valmynd fyrir hraða spilunar", Yt = "Byrja Autoscroll", Ht = "Skipta skjátexta", Vt = "Skipta þaggað", yt = "Skipta Spila/Hlé", Bt = "er {{count}} lína eftirritunar", ht = "eru {{count}} línur eftirritunar", jt = "Hleður eftirritun...", vt = "Ekki tókst að hlaða eftirritun.", Ft = "Valkostir eftirritunar", xt = "Reyna aftur", Kt = "Eftirritun ekki tiltæk", Wt = "Upp ör", $t = "Stillingar myndbands", Qt = "Magn", bt = "Magn: {{volume}}%", Jt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: s,
  A11Y_SEARCH_RESULTS_FOUND: r,
  A11Y_SEARCH_RESULTS_FOUND_other: a,
  A11Y_TIMESTAMP_JUMP_HOURS: o,
  A11Y_TIMESTAMP_JUMP_MINUTES: A,
  A11Y_TIMESTAMP_JUMP_SECONDS: E,
  A11Y_TRANSCRIPT_ERROR: i,
  A11Y_TRANSCRIPT_LINE: c,
  A11Y_TRANSCRIPT_LINES: T,
  A11Y_TRANSCRIPT_SAVING: S,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: u,
  ACTION: N,
  ADD_ANNOTATION_AT: e,
  ADD_QUESTION_AT: R,
  ANNOTATIONS: l,
  AUTO: O,
  AUTO_QUALITY: I,
  BACK: C,
  CAPTIONS: U,
  CAPTIONS_LANGUAGE: P,
  CAPTIONS_MANAGE: L,
  CAPTION_DELETE: k,
  CAPTION_FONT_SIZE: D,
  CAPTION_LANGUAGE: f,
  CAPTION_LANGUAGE_AUTOMATIC: M,
  CLEAR_SEARCH: p,
  CLOSE: m,
  COMMENTS: g,
  CONTINUE: G,
  DECREASE_PLAYBACK_SPEED: d,
  DECREASE_VOLUME: Y,
  DOWN_ARROW: H,
  EDIT_CLOSE: V,
  EDIT_CONFIRM: y,
  EDIT_ERROR: B,
  EDIT_SAVING: h,
  EDIT_SUCCESS: j,
  EDIT_TRANSCRIPT: v,
  EDIT_VALIDATION_ERROR: F,
  FULLSCREEN: x,
  HOURS: K,
  HOURS_other: W,
  INCREASE_PLAYBACK_SPEED: $,
  INCREASE_VOLUME: Q,
  INVERT_COLORS: b,
  JUMP_TO_PERCENTAGE: J,
  JUMP_TO_START: Z,
  KEBAB_MENU: X,
  KEYBOARD_SHORTCUTS: q,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: nt,
  MINUTES_other: st,
  MUTE: rt,
  MUTED: at,
  NEXT_CAPTION_LANGUAGE: ot,
  NEXT_HIT: At,
  OFF: Et,
  ON_TOP: it,
  OPEN_ANNOTATION_AT: ct,
  OPEN_COMPLETED_QUIZ_AT: Tt,
  OPEN_QUIZ_AT: St,
  PAUSE: _t,
  PLAY: ut,
  PLAYBACK_SPEED: Nt,
  PLAYBACK_SPEED_MESSAGE: et,
  PREVIOUS_CAPTION_LANGUAGE: Rt,
  PREVIOUS_HIT: lt,
  QUALITY: Ot,
  QUALITY_MENU: It,
  REPLAY: Ct,
  RESET_PLAYBACK_SPEED: Ut,
  RIGHT_ARROW: Pt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Lt,
  SECONDS: kt,
  SECONDS_other: Dt,
  SEEK_BACKWARD: ft,
  SEEK_FORWARD: Mt,
  SETTINGS: pt,
  SHORTCUT: mt,
  SIDEBAR: gt,
  SPACE: Gt,
  SPEED_MENU: dt,
  START_AUTOSCROLL: Yt,
  TOGGLE_CAPTIONS: Ht,
  TOGGLE_MUTED: Vt,
  TOGGLE_PLAY_PAUSE: yt,
  TRANSCRIPT_LINES: Bt,
  TRANSCRIPT_LINES_other: ht,
  TRANSCRIPT_LOADING: jt,
  TRANSCRIPT_LOAD_ERROR: vt,
  TRANSCRIPT_OPTIONS: Ft,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Kt,
  UP_ARROW: Wt,
  VIDEO_SETTINGS: $t,
  VOLUME: Qt,
  VOLUME_VALUE: bt
};
export {
  t as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  s as A11Y_SEARCH_NO_RESULTS,
  r as A11Y_SEARCH_RESULTS_FOUND,
  a as A11Y_SEARCH_RESULTS_FOUND_other,
  o as A11Y_TIMESTAMP_JUMP_HOURS,
  A as A11Y_TIMESTAMP_JUMP_MINUTES,
  E as A11Y_TIMESTAMP_JUMP_SECONDS,
  i as A11Y_TRANSCRIPT_ERROR,
  c as A11Y_TRANSCRIPT_LINE,
  T as A11Y_TRANSCRIPT_LINES,
  S as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  u as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  N as ACTION,
  e as ADD_ANNOTATION_AT,
  R as ADD_QUESTION_AT,
  l as ANNOTATIONS,
  O as AUTO,
  I as AUTO_QUALITY,
  C as BACK,
  U as CAPTIONS,
  P as CAPTIONS_LANGUAGE,
  L as CAPTIONS_MANAGE,
  k as CAPTION_DELETE,
  D as CAPTION_FONT_SIZE,
  f as CAPTION_LANGUAGE,
  M as CAPTION_LANGUAGE_AUTOMATIC,
  p as CLEAR_SEARCH,
  m as CLOSE,
  g as COMMENTS,
  G as CONTINUE,
  d as DECREASE_PLAYBACK_SPEED,
  Y as DECREASE_VOLUME,
  H as DOWN_ARROW,
  V as EDIT_CLOSE,
  y as EDIT_CONFIRM,
  B as EDIT_ERROR,
  h as EDIT_SAVING,
  j as EDIT_SUCCESS,
  v as EDIT_TRANSCRIPT,
  F as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  K as HOURS,
  W as HOURS_other,
  $ as INCREASE_PLAYBACK_SPEED,
  Q as INCREASE_VOLUME,
  b as INVERT_COLORS,
  J as JUMP_TO_PERCENTAGE,
  Z as JUMP_TO_START,
  X as KEBAB_MENU,
  q as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  nt as MINUTES,
  st as MINUTES_other,
  rt as MUTE,
  at as MUTED,
  ot as NEXT_CAPTION_LANGUAGE,
  At as NEXT_HIT,
  Et as OFF,
  it as ON_TOP,
  ct as OPEN_ANNOTATION_AT,
  Tt as OPEN_COMPLETED_QUIZ_AT,
  St as OPEN_QUIZ_AT,
  _t as PAUSE,
  ut as PLAY,
  Nt as PLAYBACK_SPEED,
  et as PLAYBACK_SPEED_MESSAGE,
  Rt as PREVIOUS_CAPTION_LANGUAGE,
  lt as PREVIOUS_HIT,
  Ot as QUALITY,
  It as QUALITY_MENU,
  Ct as REPLAY,
  Ut as RESET_PLAYBACK_SPEED,
  Pt as RIGHT_ARROW,
  Lt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  kt as SECONDS,
  Dt as SECONDS_other,
  ft as SEEK_BACKWARD,
  Mt as SEEK_FORWARD,
  pt as SETTINGS,
  mt as SHORTCUT,
  gt as SIDEBAR,
  Gt as SPACE,
  dt as SPEED_MENU,
  Yt as START_AUTOSCROLL,
  Ht as TOGGLE_CAPTIONS,
  Vt as TOGGLE_MUTED,
  yt as TOGGLE_PLAY_PAUSE,
  Bt as TRANSCRIPT_LINES,
  ht as TRANSCRIPT_LINES_other,
  jt as TRANSCRIPT_LOADING,
  vt as TRANSCRIPT_LOAD_ERROR,
  Ft as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Kt as TRANSCRIPT_UNAVAILABLE,
  Wt as UP_ARROW,
  $t as VIDEO_SETTINGS,
  Qt as VOLUME,
  bt as VOLUME_VALUE,
  Jt as default
};
